import {
  formatInternational,
  getCountryCodeFromPhoneNumber,
  getPhoneNumberCountryCodeFormatted,
} from 'lib-shared-phone-numbers';
import { useMemo } from 'react';

import { PhoneNumber } from 'apis/numbers';

export type SelectedFromNumberPresentation = {
  fromNumberFlagCountryCode: string | null;
  fromNumberCountryCode: string | null;
  fromNumberFormat: string | null;
};

const emptyRepresentation: SelectedFromNumberPresentation = {
  fromNumberFlagCountryCode: null,
  fromNumberCountryCode: null,
  fromNumberFormat: null,
};

// Derives all UI-facing values from the currently selected number so callers
// do not need to mirror Redux state into local component state.
export function getSelectedFromNumberPresentation(
  selectedFromNumber: PhoneNumber | null,
): SelectedFromNumberPresentation {
  if (!selectedFromNumber) {
    return emptyRepresentation;
  }

  return {
    fromNumberFormat:
      formatInternational(selectedFromNumber.e164_format) ||
      selectedFromNumber.e164_format,
    // The flag uses an ISO country code (for CSS classes) while search and
    // validation use the dialling prefix like "+1".
    fromNumberFlagCountryCode:
      getCountryCodeFromPhoneNumber(
        selectedFromNumber.e164_format,
      )?.toUpperCase() || null,
    fromNumberCountryCode:
      getPhoneNumberCountryCodeFormatted(selectedFromNumber.e164_format) ||
      null,
  };
}

export function useSelectedFromNumberPresentation(
  selectedFromNumber: PhoneNumber | null,
): SelectedFromNumberPresentation {
  return useMemo(
    () => getSelectedFromNumberPresentation(selectedFromNumber),
    [selectedFromNumber],
  );
}
